import React from 'react';
import { Settings2, ChevronDown, Play, Code2, Database, Variable } from 'lucide-react';
interface RightSidebarProps {
  selectedNodeId: string | null;
}
export function RightSidebar({
  selectedNodeId
}: RightSidebarProps) {
  if (!selectedNodeId) {
    return <aside className="w-[320px] h-full bg-[#0b101d] border-l border-slate-800/60 flex flex-col shrink-0 items-center justify-center text-slate-500 p-6 text-center" data-id="element-83">
        <Settings2 className="w-8 h-8 mb-3 opacity-50" data-id="element-84" />
        <p className="text-sm" data-id="element-85">
          Select a node on the canvas to view and edit its properties.
        </p>
      </aside>;
  }
  // Hardcoded for the "Claude AI Summarise" node based on prompt
  return <aside className="w-[320px] h-full bg-[#0b101d] border-l border-slate-800/60 flex flex-col shrink-0 overflow-y-auto" data-id="element-86">
      <div className="p-4 border-b border-slate-800/60 flex items-center justify-between sticky top-0 bg-[#0b101d]/90 backdrop-blur z-10" data-id="element-87">
        <h2 className="text-sm font-semibold text-slate-200 flex items-center gap-2" data-id="element-88">
          <Settings2 className="w-4 h-4 text-sky-400" data-id="element-89" />
          Node Properties
        </h2>
      </div>

      <div className="p-4 space-y-6" data-id="element-90">
        {/* Basic Info */}
        <div className="space-y-3" data-id="element-91">
          <div data-id="element-92">
            <label className="block text-xs font-medium text-slate-400 mb-1.5" data-id="element-93">
              Node Name
            </label>
            <input type="text" defaultValue="Claude AI Summarise" className="w-full bg-slate-900 border border-slate-800 rounded-md py-1.5 px-3 text-sm text-slate-200 focus:outline-none focus:border-sky-500/50 focus:ring-1 focus:ring-sky-500/50" data-id="element-94" />
          </div>
          <div data-id="element-95">
            <label className="block text-xs font-medium text-slate-400 mb-1.5" data-id="element-96">
              Model
            </label>
            <div className="relative" data-id="element-97">
              <select className="w-full bg-slate-900 border border-slate-800 rounded-md py-1.5 pl-3 pr-8 text-sm text-slate-200 appearance-none focus:outline-none focus:border-sky-500/50 focus:ring-1 focus:ring-sky-500/50" data-id="element-98">
                <option data-id="element-99">Claude 3.5 Sonnet</option>
                <option data-id="element-100">Claude 3 Opus</option>
                <option data-id="element-101">Claude 3 Haiku</option>
              </select>
              <ChevronDown className="absolute right-2.5 top-2 w-4 h-4 text-slate-500 pointer-events-none" data-id="element-102" />
            </div>
          </div>
        </div>

        <div className="h-px w-full bg-slate-800/60" data-id="element-103" />

        {/* Prompt Configuration */}
        <div className="space-y-3" data-id="element-104">
          <div className="flex items-center justify-between" data-id="element-105">
            <label className="block text-xs font-medium text-slate-400" data-id="element-106">
              System Prompt
            </label>
            <button className="text-[10px] text-sky-400 hover:text-sky-300 flex items-center gap-1" data-id="element-107">
              <Code2 className="w-3 h-3" data-id="element-108" /> Edit JSON
            </button>
          </div>
          <textarea rows={5} defaultValue="You are an expert executive assistant. Read the following email and provide a concise 2-3 sentence summary highlighting any urgent action items or deadlines." className="w-full bg-slate-900 border border-slate-800 rounded-md py-2 px-3 text-sm text-slate-300 focus:outline-none focus:border-sky-500/50 focus:ring-1 focus:ring-sky-500/50 resize-none font-mono text-[13px] leading-relaxed" data-id="element-109" />
        </div>

        {/* Input Mapping */}
        <div className="space-y-3" data-id="element-110">
          <label className="block text-xs font-medium text-slate-400" data-id="element-111">
            Input Variables
          </label>
          <div className="p-3 rounded-md bg-slate-900/50 border border-slate-800 border-dashed space-y-2" data-id="element-112">
            <div className="flex items-center gap-2" data-id="element-113">
              <span className="text-xs text-slate-500 w-12" data-id="element-114">Input</span>
              <div className="flex-1 flex items-center gap-1.5 px-2 py-1 rounded bg-sky-500/10 border border-sky-500/20 text-sky-400 text-xs font-mono" data-id="element-115">
                <Variable className="w-3 h-3" data-id="element-116" />
                {`{{email.body}}`}
              </div>
            </div>
          </div>
        </div>

        {/* Parameters */}
        <div className="space-y-4" data-id="element-117">
          <div data-id="element-118">
            <div className="flex items-center justify-between mb-1.5" data-id="element-119">
              <label className="block text-xs font-medium text-slate-400" data-id="element-120">
                Temperature
              </label>
              <span className="text-xs text-slate-500 font-mono" data-id="element-121">0.2</span>
            </div>
            <input type="range" min="0" max="1" step="0.1" defaultValue="0.2" className="w-full accent-sky-500" data-id="element-122" />
          </div>
          <div data-id="element-123">
            <label className="block text-xs font-medium text-slate-400 mb-1.5" data-id="element-124">
              Max Tokens
            </label>
            <input type="number" defaultValue="250" className="w-full bg-slate-900 border border-slate-800 rounded-md py-1.5 px-3 text-sm text-slate-200 focus:outline-none focus:border-sky-500/50 focus:ring-1 focus:ring-sky-500/50 font-mono" data-id="element-125" />
          </div>
        </div>

        <div className="h-px w-full bg-slate-800/60" data-id="element-126" />

        {/* Output */}
        <div className="space-y-3" data-id="element-127">
          <label className="block text-xs font-medium text-slate-400" data-id="element-128">
            Output Variable
          </label>
          <div className="flex items-center gap-2 px-3 py-1.5 rounded-md bg-slate-900 border border-slate-800" data-id="element-129">
            <Database className="w-3.5 h-3.5 text-slate-500" data-id="element-130" />
            <input type="text" defaultValue="summary_result" className="bg-transparent border-none text-sm text-slate-200 focus:outline-none w-full font-mono" data-id="element-131" />
          </div>
        </div>
      </div>

      {/* Bottom Action */}
      <div className="mt-auto p-4 border-t border-slate-800/60 bg-[#0b101d] sticky bottom-0" data-id="element-132">
        <button className="w-full flex items-center justify-center gap-2 py-2 rounded-md bg-slate-800 hover:bg-slate-700 text-slate-200 text-sm font-medium transition-colors border border-slate-700" data-id="element-133">
          <Play className="w-4 h-4" data-id="element-134" />
          Test Node
        </button>
      </div>
    </aside>;
}